import { defineComponent as _defineComponent } from 'vue'
import InstrumentAvatar from '@/modules/trade/components/InstrumentAvatar/InstrumentAvatar.vue';
import { IStructuredOperationsSelection } from '@/modules/transaction/services/product-investment';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonBoxIcon,
  HeadingDisplay
} from '@warrenbrasil/nebraska-web';
import { inject, Ref, ref } from 'vue';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectStep',
  setup(__props) {

const route = useRoute();
const structuredOperationsSelection = inject(
  'structuredOperationsSelection'
) as Ref<IStructuredOperationsSelection>;

const isFetchingQuantityOperation = ref(false);
const isFetchingValueOperation = ref(false);

const fetchCustomOperationInfo = inject(
  'fetchProductInfo',
  (productId: string, quantity: number, useBaseAsset?: boolean) => ({
    productId,
    quantity,
    useBaseAsset
  })
);

const useBaseAssetChoice = inject('useBaseAssetChoice') as Ref<boolean | null>;

async function goToQuantityInvestment() {
  try {
    isFetchingQuantityOperation.value = true;
    useBaseAssetChoice.value = true;
    await fetchCustomOperationInfo(route.params.id, 0, true);
  } finally {
    isFetchingQuantityOperation.value = false;
  }
}

async function goToValueInvestment() {
  try {
    isFetchingValueOperation.value = true;
    useBaseAssetChoice.value = false;
    await fetchCustomOperationInfo(route.params.id, 0, false);
  } finally {
    isFetchingValueOperation.value = false;
  }
}

return { __sfc: true,route, structuredOperationsSelection, isFetchingQuantityOperation, isFetchingValueOperation, fetchCustomOperationInfo, useBaseAssetChoice, goToQuantityInvestment, goToValueInvestment, InstrumentAvatar, NebraskaColors, BaseText, ButtonBoxIcon, HeadingDisplay }
}

})